import type { TPopoverFloatingPlacement } from '../types/TProps';

const OPPOSITE_PLACEMENT: Record<TPopoverFloatingPlacement, TPopoverFloatingPlacement> = {
  'bottom-end': 'top-end',
  'bottom-start': 'top-start',
  'top-end': 'bottom-end',
  'top-start': 'bottom-start',
};

export type TInitialPlacementInput = {
  preferredPlacement: TPopoverFloatingPlacement;
  anchorTop: number;
  anchorBottom: number;
  viewportHeight: number;
  desiredHeight: number;
  offset: number;
  padding: number;
};

export const getInitialPlacement = ({
  preferredPlacement,
  anchorTop,
  anchorBottom,
  viewportHeight,
  desiredHeight,
  offset,
  padding,
}: TInitialPlacementInput) => {
  const spaceBelow = viewportHeight - anchorBottom - offset - padding;
  const spaceAbove = anchorTop - offset - padding;
  const prefersBottom = preferredPlacement.startsWith('bottom');
  const preferredSpace = prefersBottom ? spaceBelow : spaceAbove;
  const oppositeSpace = prefersBottom ? spaceAbove : spaceBelow;

  if (preferredSpace >= desiredHeight || oppositeSpace <= preferredSpace) {
    return preferredPlacement;
  }

  return OPPOSITE_PLACEMENT[preferredPlacement];
};
